// src/App.js
import React from 'react';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import '@aws-amplify/ui-react/styles.css';
import './styles/common.css';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';

import DownloadPage from './pages/DownloadPage';
import LicenseRoutes from './LicenseRoutes';

Amplify.configure(awsExports);

const LazyRequireAuth = React.lazy(() => import('./RequireAuth'));

function AppRoutes() {
  const location = useLocation();
  const pathname = location.pathname;

  console.log('[AppRoutes] pathname:', pathname);

  return (
    <Routes>
    <Route path="/download/:productId" element={<DownloadPage />} />

    <Route
      path="/license/*"
      element={
        <React.Suspense fallback={<div>Loading...</div>}>
          <LazyRequireAuth />
        </React.Suspense>
      }
    />

    {/* その他はアクセス不可表示 */}
    <Route
      path="*"
      element={
        <div className="container">
          <h1 className="title">このページにはアクセスできません</h1>
        </div>
      }
    />
  </Routes>

  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
